import { Col, Row } from 'antd';

const ContentView = ({ content, navigator }) => {
    return (
        <div style={{ padding: '2rem', margin: "auto" }}>
            <Row gutter={[96, 64]} justify="center" align={'top'}>
                <Col flex={'0 0 550px'} style={{ maxHeight: 1000, overflowY: 'scroll' }}>
                    {content}
                </Col>
                <Col flex={'0 0 300px'}>
                    {navigator}
                </Col>
            </Row>
        </div>
    );
};

export default ContentView;